import Phaser from 'phaser';
import Forces from '../math/Forces';
import ABCyaPhaser from '@abcya/abcya_phaser';
import UIAssetKeys from '../UIAssetKeys';
import SantaFollowSprite from './SantaFollowSprite';
import Caboose from './Caboose';
import SoundAssetKeys from '../SoundAssetKeys';

export default class Santa extends Phaser.GameObjects.Container {
  /**
   * 
   * @param {Phaser.Scene} scene 
   */
  constructor(scene) {
    super(scene);

    this.santa = null;

    this.mass = 1.0;
    this.gravity = 800;
    this.k = 0.2;

    this.ropes = new Phaser.GameObjects.Graphics(this.scene);

    this.centerPrev = new Phaser.Math.Vector2();
    this.centerNext = new Phaser.Math.Vector2();

    this.topLimit = -100;
    this.bottomLimit = this.scene.scale.height - 50;

    this.gravityForce = new Phaser.Math.Vector2();
    this.dragForce = new Phaser.Math.Vector2();
    this.frictionForce = new Phaser.Math.Vector2();
    Forces.constantGravity(this.mass, this.gravity, this.gravityForce);
    this.totalForce = new Phaser.Math.Vector2();

    this.pos = new Phaser.Math.Vector2(485,200);
    this.vel = new Phaser.Math.Vector2(0, 0);
    this.acc = new Phaser.Math.Vector2();

    this.reindeer = [];

    this.driver = ABCyaPhaser.Images.addImage(0,0,UIAssetKeys._Reindeer, this);

    this.followers = [];

    // F1
    let follower = new SantaFollowSprite(this.scene);
    follower.pos.x = this.pos.x - 44;
    follower.pos.y = this.pos.y;

    this.add(follower);
    this.followers.push(follower);

    // F2
    follower = new SantaFollowSprite(this.scene);
    follower.pos.x = this.pos.x - 88;
    follower.pos.y = this.pos.y;
    this.add(follower);
    this.followers.push(follower);

    // F3
    follower = new Caboose(this.scene);
    follower.pos.x = this.pos.x - 230;
    follower.pos.y = this.pos.y;
    this.add(follower);
    this.followers.push(follower);
    follower.setDisplayOrigin(0, 50);

    this.add(this.ropes);

    this.noseContainer = new Phaser.GameObjects.Container(this.scene);
    this.noseOutside = ABCyaPhaser.Images.addImage(0,0,UIAssetKeys._Nose_1, this.noseContainer).setOrigin(0);
    this.noseInside = ABCyaPhaser.Images.addImage(2,2,UIAssetKeys._Nose_2, this.noseContainer).setOrigin(0);

    this.noseOutside.alpha = 0;
    this.noseInside.alpha = 0.3;

    ABCyaPhaser.Tweens.addTween(this.noseOutside, 500, { alpha: 0.8, yoyo: true, loop: -1, hold: 300 }, Phaser.Math.Easing.Linear);

    const noseInsideAnimation = () => {
      ABCyaPhaser.Tweens.addTween(this.noseInside, 600, { alpha: 1, completeDelay: 200 }, Phaser.Math.Easing.Linear, () => {
        ABCyaPhaser.Tweens.addTween(this.noseInside, 500, { alpha: 0.3 }, Phaser.Math.Easing.Linear, () => noseInsideAnimation());
      });
    };
    this.add(this.noseContainer);

    this.jumpSound = ABCyaPhaser.Audio.createSound(this.scene);

    this.once(Phaser.GameObjects.Events.DESTROY, () => this.jumpSound.destroy());
  }

  hideNose () {
    this.noseContainer.setVisible(false);
  }

  showNose () {
    this.noseContainer.setVisible(true);
  }

  setGamePlayLimits () {
    this.bottomLimit = this.scene.scale.height - 25;
  }

  setIntroLimits () {
    this.bottomLimit = 420;
  }

  /**
 * 
 * @param {SantaFollowSprite | Caboose} obj 
 * @param {number} num 
 * @param {number} dt 
 */
  calcFollowerForce (obj, num, dt) {
    if (num > 0) {
      this.centerPrev.set(this.followers[num - 1].pos.x,this.followers[num - 1].pos.y);
    }
    else {
      this.centerPrev.set(this.pos.x, this.pos.y);
    }
    if (num < this.followers.length - 1) {
      this.centerNext.set(this.followers[num + 1].pos.x,this.followers[num + 1].pos.y);
    }
    else {
      this.centerNext.set(obj.pos.x, obj.pos.y);
    }
    obj.calcForce(this.centerPrev, this.centerNext);
    obj.updateVelocity(dt);
  }

  // endregion

  changeVel (xf,yf) {
    this.vel.x *= xf;
    this.vel.y *= yf;
  }

  jump (strength) {
    this.jumpSound.stop();
    ABCyaPhaser.Audio.playSound(SoundAssetKeys._jump2, this.jumpSound);
    this.vel.y = -strength;
  }

  updatePos () {
    this.driver.x = this.pos.x;
    this.driver.y = this.pos.y;
    this.noseContainer.x = this.pos.x + 12;
    this.noseContainer.y = this.pos.y - 13;
  }

  move (dt) {
    this.pos.add({ x: this.vel.x * dt, y: this.vel.y * dt });
    if (this.pos.y > this.bottomLimit) this.pos.y = this.bottomLimit;

    const len = this.followers.length;
    for (let i = 0; i < len; i++) {
      const f = this.followers[i];
      f.move(dt);
      f.updatePos();
      this.calcFollowerForce(f, i, dt);
    }

    this.ropes.clear();
    this.ropes.lineStyle(2, 0xef4136).beginPath();
    this.ropes.moveTo(this.pos.x, this.pos.y);
    for (let i = 0; i < len; i++) {
      const f = this.followers[i];
      if (i === 0) {
        this.ropes.lineTo(this.followers[i].pos.x, this.followers[i].pos.y + 2);
      }
      else if (i < this.followers.length - 1) {
        this.ropes.lineTo(this.followers[i].pos.x + this.followers[i + 1].originX, this.followers[i].pos.y + 2);
      }
      else {
        this.ropes.lineTo(this.followers[i].pos.x + 90, this.followers[i].pos.y + 2);
      }
    }
    this.ropes.strokePath();
  }

  calcForce () {
    this.dragForce.set(this.vel.x, this.vel.y);
    Forces.linearDrag(this.k, this.vel, this.dragForce);
    Forces.add([this.gravityForce],this.totalForce);
  }

  updateAccel () {
    this.totalForce.multiply({ x: 1 / this.mass, y: 1 / this.mass });
  }

  updateVelocity (dt) {
    this.vel.add({ x: this.totalForce.x * dt, y: this.totalForce.y * dt });
  }

  collectPresent () {
    this.followers[2].wave();
  }

  isOutOfBounds () {
    let out = false;
    out = this.pos.y > this.bottomLimit - 25 || this.pos.y < 0;
    return out;
  }

  tick (dt) {
    this.calcForce();
    this.updateAccel();
    this.updateVelocity(dt);
  }
}